import { z } from "zod";

export const CancelPrivateLessonPackageSchema = z.object({
  cancelReason: z.string().min(1, "ກະລຸນາປ້ອນໝາຍເຫດ"),
});

export type CancelPrivateLessonPackageDTO = z.infer<
  typeof CancelPrivateLessonPackageSchema
>;
